module.exports = __webpack_public_path__ + "0688706a.svg";